// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getPartnerSpares(_, data) {
            const response = await axios.get(`${MAIN_API}/api/sharepart/partner`, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async getSparesCatalog(_, data) {
            const response = await axios.get(`${MAIN_API}/api/sharepart/directory/all`, {
                headers: { 'Content-Type': 'application/json' },
                params: data
            })
            return response.data
        },
        async createSpare(_, formData) {
            const response = await axios.post(`${MAIN_API}/api/sharepart/directory/create`, formData)
            return response.data
        },
        async addPartnerSpare(_, data) {
            const response = await axios.post(`${MAIN_API}/api/sharepart/partner/create`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async getSpareBrands() {
            const response = await axios.get(`${MAIN_API}/api/sharepart/brand`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
